export default {
  // Config
  apiKey: "AIzaSyCkJs8K-RQE1hYX31PbIyroa5E-4hS99ho",
  authDomain: "muhameds-mytrace.firebaseapp.com",
  projectId: "muhameds-mytrace",
  storageBucket: "muhameds-mytrace.firebasestorage.app",
  messagingSenderId: "801675603560",
  appId: "1:801675603560:web:5aef4288a08c472cf455dd"
};
